import React from 'react';
interface BookingButtonProps {
  text?: string;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  href?: string;
}
const CALENDLY_URL = 'https://calendly.com/valerdura-coaching/sesiune-descoperire';
export function BookingButton({
  text = 'Vreau o Diagnosticare Gratuită a Companiei',
  className = '',
  variant = 'primary'
}: BookingButtonProps) {
  const href = CALENDLY_URL;
  const baseStyles = "inline-block font-['Montserrat'] text-[15px] font-bold rounded-xl transition-all duration-300 text-center no-underline";
  const variants = {
    primary: 'bg-[#1D4ED8] text-white px-8 py-4 shadow-[0_8px_24px_rgba(29,78,216,0.4)] hover:bg-[#2563EB] hover:-translate-y-1',
    secondary: 'bg-white text-[#1D4ED8] px-8 py-4 shadow-[0_8px_24px_rgba(0,0,0,0.1)] hover:bg-[#F1F5F9] hover:-translate-y-1',
    outline: 'bg-transparent text-white border-2 border-white px-8 py-4 hover:bg-white hover:text-[#09111F] hover:-translate-y-1'
  };
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-41">
      {text}
    </a>;
}